import { render, staticRenderFns } from "./PhaseStepper.vue?vue&type=template&id=10171560"
import script from "./PhaseStepper.vue?vue&type=script&lang=js"
export * from "./PhaseStepper.vue?vue&type=script&lang=js"
import style0 from "./PhaseStepper.vue?vue&type=style&index=0&id=10171560&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports